import {defineAsyncComponent} from 'vue'
const PaymentsRouter = [
  {
    path: 'bank_cards',
    name: 'BankCards',
    component: () => import('@/views/Payments/BankCards/Index.vue'),
    meta: {
      key: 'payment'
    }
  },
  {
    path: 'payment_platforms',
    name: 'PaymentPlatforms',
    component: () => import('@/views/Payments/PaymentPlatforms/Index.vue'),
    meta: {
      key: 'payment'
    }
  },
  {
    path: 'payment_signs',
    name: 'PaymentSigns',
    component: () => import('@/views/Payments/PaymentSigns/Index.vue'),
    meta: {
      key: 'payment'
    }
  },
  {
    path: 'incomes_apply',
    name: 'IncomesApply',
    component: () => import('@/views/Payments/IncomesApply/Index.vue'),
    meta: {
      key: 'payment'
    }
  },
  {
    path: 'incomes_detail',
    name: 'IncomesDetail',
    component: () => import('@/views/Payments/IncomesDetail/Index.vue'),
    meta: {
      key: 'payment'
    }
  },
  {
    path: 'payment_detail',
    name: 'PaymentDetails',
    component: () => import('@/views/Payments/PaymentDetails/Index.vue'),
    meta: {
      key: 'payment'
    }
  },
  {
    path: 'payment_batches',
    name: 'PaymentBatches',
    component: () => import('@/views/Payments/PaymentBatches/Index.vue'),
    meta: {
      key: 'payment'
    }
  },
]
export {PaymentsRouter}
